__webpack_require__.p = "/npm-update-packages/referrals/";